import type { ReactNode } from "react";
import { PopoverContent } from "~/components/ui/popover";
import { Text } from "~/components/text";

interface KeywordFeedbackPopoverContentProps {
  title: string;
  subtitle?: string | null;
  children: ReactNode;
}

export const KeywordFeedbackPopoverContent = ({
  title,
  subtitle,
  children,
}: KeywordFeedbackPopoverContentProps) => (
  <PopoverContent side="right" align="start" className="w-80 p-0">
    <div className="flex flex-col">
      <div className="flex flex-col gap-0.5 px-4 pt-3 pb-2 bg-secondary-50/50 rounded-t-lg">
        <Text as="span" variant="labelSmall">
          {title}
        </Text>
        {subtitle && (
          <Text as="span" variant="caption">
            {subtitle}
          </Text>
        )}
      </div>
      <div className="border-t border-secondary-100" />
      {children}
    </div>
  </PopoverContent>
);
